var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.sumModalProps,
        title: _vm.title
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c(
            "div",
            { staticClass: "items-list" },
            [
              _c("webcameras-settings", {
                attrs: { webcameras: _vm.webcameras },
                on: { "change-input-video-device": _vm.changeInputVideoDevice }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "items-list" },
            [
              _c("microphones-settings", {
                attrs: { microphones: _vm.microphones },
                on: { "change-input-audio-device": _vm.changeInputAudioDevice }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "items-list" },
            [
              _c("speakers-settings", {
                attrs: { speakers: _vm.speakers },
                on: {
                  "change-output-audio-device": _vm.changeOutputAudioDevice
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "btn poll-button-cancel", on: { click: _vm.close } },
          [_vm._v(_vm._s(_vm.$t("close")))]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }